// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2TYvD","footer":"ModalInfo_footer__1QbEw"};